/* eslint-disable import/no-webpack-loader-syntax */

import edlFragmentShader from "!!raw-loader!./edl.frag";
import edlVertexShader from "!!raw-loader!./edl.vert";
import opacityFragmentShader from "!!raw-loader!./opacity.frag";
import opacityVertexShader from "!!raw-loader!./opacity.vert";
import pointCloudFragmentShader from "!!raw-loader!./pointcloud.frag";
import pointCloudVertexShader from "!!raw-loader!./pointcloud.vert";
import panoramicFragmentShader from "!!raw-loader!./panoramic.frag";
import panoramicVertexShader from "!!raw-loader!./panoramic.vert";
import planarFragmentShader from "!!raw-loader!./planar.frag";
import planarVertexShader from "!!raw-loader!./planar.vert";
import imageFragmentShader from "!!raw-loader!./image.frag";
import imageVertexShader from "!!raw-loader!./image.vert";
import markersFragmentShader from "!!raw-loader!./markers.frag";
import markersVertexShader from "!!raw-loader!./markers.vert";
import utilitiesVertexShader from "!!raw-loader!./utilities.vert";
import utilitiesFragmentShader from "!!raw-loader!./utilities.frag";
import gpuPickerFragmentShader from "!!raw-loader!./gpu_picker.frag";
import gpuPickerVertexShader from "!!raw-loader!./gpu_picker.vert";
import texturePackVertexShader from "!!raw-loader!./texture_pack.vert";
import tagsFragmentShader from "!!raw-loader!./tags.frag";
import tagsVertexShader from "!!raw-loader!./tags.vert";
import basicPickerFragmentShader from "!!raw-loader!./picker_basic.frag";
import basicPickerVertexShader from "!!raw-loader!./picker_basic.vert";
import spriteFragmentShader from "!!raw-loader!./sprite.frag";
import spriteVertexShader from "!!raw-loader!./sprite.vert";

const shaders = {
  pointcloud: {
    vert: pointCloudVertexShader,
    frag: pointCloudFragmentShader
  },
  panoramic: {
    vert: panoramicVertexShader,
    frag: panoramicFragmentShader
  },
  planar: {
    vert: planarVertexShader,
    frag: planarFragmentShader
  },
  edl: {
    vert: edlVertexShader,
    frag: edlFragmentShader
  },
  opacity: {
    vert: opacityVertexShader,
    frag: opacityFragmentShader
  },
  image: {
    vert: imageVertexShader,
    frag: imageFragmentShader
  },
  markers: {
    vert: markersVertexShader,
    frag: markersFragmentShader
  },
  utilities: {
    vert: utilitiesVertexShader,
    frag: utilitiesFragmentShader
  },
  basic_picker: {
    vert: basicPickerVertexShader,
    frag: basicPickerFragmentShader
  },
  gpu_picker: {
    vert: gpuPickerVertexShader,
    frag: gpuPickerFragmentShader
  },
  texture_packer: {
    vert: texturePackVertexShader
  },
  tags: {
    vert: tagsVertexShader,
    frag: tagsFragmentShader
  },
  sprite: {
    vert: spriteVertexShader,
    frag: spriteFragmentShader
  }
};

export default shaders;